import React, { useEffect, useState } from "react";
import axios from "axios";
import "./FisherManList.css";
interface Fisherman {
  _id: string;
  name: string;
  mobileNumber: string;
  communityId?: string;
  createdBy?: string;
  digitalId?: string;
  upiid?: string;
  amountPaid?: string | number;
  wasteCollected?: string | number;
  image?: string;
}

const FishermanList = () => {
  const [fishermen, setFishermen] = useState<Fisherman[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFishermen = async () => {
      try {
        const userToken = localStorage.getItem("auth-token");
        const response = await axios.get(
          "https://universal-code-stage.ctyloop.in/v1/fisherman/allfisherman?pageNo=0&pageSize=10",
          {
            headers: {
              "x-user-token": userToken,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (!response) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.data;
        setFishermen(result.data);
      } catch (err) {
        setError("Something went wrong while fetching fishermen.");
      } finally {
        setLoading(false);
      }
    };
    fetchFishermen();
  }, []);

  if (loading) return <div className="fisherman-container">Loading...</div>;
  if (error) return <div className="fisherman-container">Error: {error}</div>;

  return (
    <div className="fisherman-container" style={{ maxWidth: "1300px" }}>
      <h1>Registered Fisherman</h1>
      <div className="table-container">
        <table className="fisherman-table">
          <thead>
            <tr>
              <th>IMAGE</th>
              <th>NAME</th>
              <th>MOBILE NUMBER</th>
              <th>DIGITAL ID</th>
              <th>UPI ID</th>
              <th>AMOUNT PAID</th>
              <th>WASTE COLLECTED</th>
            </tr>
          </thead>
          <tbody>
            {fishermen.map((f) => (
              <tr key={f._id}>
                <td>
                  {f.image ? (
                    <img src={f.image} alt={f.name} className="avatar-img" />
                  ) : (
                    <div className="avatar-placeholder">No Image</div>
                  )}
                </td>
                <td>{f.name}</td>
                <td>{f.mobileNumber}</td>
                <td>{f.digitalId}</td>
                <td>{f.upiid || "N/A"}</td>
                <td>{f.amountPaid || "N/A"}</td>
                <td>{f.wasteCollected || "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FishermanList;
